import React from "react";
import CardHeader from "peggirkit/dist/components/Card/CardHeading/CardHeader";
import {Card, DescriptionCardHeading, FormLayout, FormLayoutSectionFormatProps} from "peggirkit";
import {slimCardFormLayoutProps} from "@widgets/layout/formLayout/FormLayout";
import FormLayoutSection from "peggirkit/dist/components/Form/Layout/LayoutSection/FormLayoutSection";
import {FormattedMessage, useIntl} from "react-intl";
import EmployeeDetailsForm from "@widgets/employees/editor/sections/EmployeeDetailsForm";
import {SetEmployeeProps} from "@pages/authenticated/admin/employees/Employee";

type Props = SetEmployeeProps & {
    initialLoading: boolean,
};

const EmployeeDetailsCard = ({employee, setEmployee, initialLoading}: Props) => {
    const intl = useIntl();

    return (
        <Card
            header={
                <CardHeader>
                    <DescriptionCardHeading
                        title={intl.formatMessage({id: "details"})}
                        description={intl.formatMessage({id: "viewOrEditEmployeeDetails"})}
                    />
                </CardHeader>
            }
        >
            <FormLayout {...slimCardFormLayoutProps}>
                {(layoutProps: FormLayoutSectionFormatProps) => (
                    <>
                        <FormLayoutSection
                            {...layoutProps}
                            title={<FormattedMessage id={"general"}/>}
                            description={<FormattedMessage id={"generalPersonData"}/>}
                            noBorder
                            noPadding
                        >
                            <EmployeeDetailsForm
                                setEmployee={setEmployee}
                                employee={employee}
                                initialLoading={initialLoading}
                            />
                        </FormLayoutSection>
                    </>
                )}
            </FormLayout>
        </Card>
    );
};

export default EmployeeDetailsCard;